
import Vue from 'vue';
import { TOKEN_STATUS_COLOR, TokenStatus } from '@/utils/tokenBuckets';

/**
 * The sidebar token ring. Purely presentational: the parent decides which direction `fill` runs
 * (see deriveRingFill in utils/tokenBuckets.ts — consumers drain from full, enterprise teams fill
 * up against their budget), this just draws the arc and colors it by status.
 *
 * The arc is dropped entirely at fill 0 because a zero-length dash with a round linecap still
 * paints a dot. That would leave a stray tick floating at 12 o'clock on an empty ring — so the
 * depleted signal moves to the track, which reads as a red outline with nothing in it.
 */
export default Vue.extend({
	name: 'TokenUsageRing',
	props: {
		fill: { type: Number, default: 0 }, // 0..1, clamped
		status: { type: String, default: 'ok' }, // TokenStatus
		size: { type: Number, default: 20 },
	},
	data () {
		return {
			CIRCUMFERENCE: 43.98, // 2π × r(7)
			NEUTRAL_TRACK: 'rgba(255,255,255,0.16)',
			DEPLETED_TRACK: 'rgba(255,92,122,0.3)', // TOKEN_STATUS_COLOR.depleted, dimmed
		};
	},
	computed: {
		dashLength (): number {
			const clamped: number = Math.min(Math.max(this.fill, 0), 1);
			return clamped * this.CIRCUMFERENCE;
		},
		strokeColor (): string {
			return TOKEN_STATUS_COLOR[this.status as TokenStatus] || TOKEN_STATUS_COLOR.ok;
		},
		trackColor (): string {
			return this.status === 'depleted' ? this.DEPLETED_TRACK : this.NEUTRAL_TRACK;
		},
	},
});
